import { getRoutes } from "../router/getRoutes";
import { getServerManifest } from "./getServerManifest";
function createMockModuleWithContext() {
  var map = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var contextModule = function contextModule2(key) {
    return {
      default() {
      }
    };
  };
  Object.defineProperty(contextModule, "keys", {
    value: function value() {
      return map;
    }
  });
  return contextModule;
}
function createRoutesManifest(paths, options) {
  var routeTree = getRoutes(createMockModuleWithContext(paths), {
    ...options,
    preserveApiRoutes: true,
    ignoreRequireErrors: true,
    ignoreEntryPoints: true,
    platform: "web"
  });
  if (!routeTree) {
    throw new Error(`No route tree found in paths: ${JSON.stringify(paths)}`);
  }
  return getServerManifest(routeTree);
}
export {
  createRoutesManifest
};
//# sourceMappingURL=createRoutesManifest.js.map
